export const GUIDE_All_FILTER_SET = 'GUIDE_All_FILTER_SET';

export const GUIDE_FILTER_UPDATE = 'GUIDE_FILTER_UPDATE';

export const GUIDE_FILTER_SET = 'GUIDE_FILTER_SET';

export const GUIDE_FILTER_CLEAR = 'GUIDE_FILTER_CLEAR';
